import React, {useEffect} from 'react';
import {useStyles} from "./styles/NoticeStyle";
import {
    Box,
    TablePagination,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Button,
    Typography, FormControlLabel, Switch, Card
} from "@material-ui/core";
import PropTypes from 'prop-types';
import {ReactComponent as AlignLeftIcon} from '../../../common/images/AlignLeftIcon.svg';
import {ReactComponent as TextFieldDownIcon} from '../../../common/images/TextFieldDownIcon.svg';
import {ReactComponent as TableSortIcon} from '../../../common/images/TableSortIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import {useHistory} from "react-router-dom";
import NoImage from "../../../common/images/NoImage.jpg";
import {NotificationType} from "../../../stores/NoticeStore";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function NoticeHome(props) {
    const classes = useStyles();
    const history = useHistory();
    const {intl} = props;
    const {authStore, noticeStore, localeStore} = props;

    useEffect(() => {
        noticeStore.getNotifications(authStore.loginUser.id, localeStore.locale);
        noticeStore.setSortColumn("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localeStore.locale]);

    const handleChangePage = (event, newPage) => {
        noticeStore.setPage(newPage, authStore.loginUser.id, localeStore.locale);
    };

    const handleChangeRowsPerPage = (event) => {
        noticeStore.setRowsPerPage(parseInt(event.target.value, 10), authStore.loginUser.id, localeStore.locale);
    };

    const handleClickCreatedDateSort = () => {
        if (noticeStore.sortColumn === 'register_date') {
            noticeStore.setIsAscending(!noticeStore.isAscending);
        } else {
            noticeStore.setSortColumn('register_date');
            noticeStore.setIsAscending(false);
        }
        noticeStore.getNotifications(authStore.loginUser.id, localeStore.locale);
    };

    const handelClickManage = (noticeId) => {
        history.push(`/notice/${noticeId}/lang/${localeStore.locale.toUpperCase()}`);
    }

    const handleClickEnabled = (enable, id) => {
        noticeStore.updateNotificationEnable(enable, id);

        if (noticeStore.enableCheck) {
            const updatedNotices = noticeStore.noticeList.map(notice => {
                if (notice.id === id) {
                    return {...notice, enable: !notice.enable};
                }
                return notice;
            });
            noticeStore.setNoticeList(updatedNotices);
        }
    }

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"flex-end"}>
                <Box marginRight={2} marginBottom={2}>
                    <Button className={classes.tableButton2} disableRipple
                            onClick={() => handelClickManage(0)}>{intl.formatMessage({id: "written"})}</Button>
                </Box>
            </Box>
            <Box>
                <Box>
                    <TableContainer className={classes.tableBox}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead className={classes.tableHeadStyle}>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{minWidth: 55}}
                                    >
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{"No"}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "type"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{width: 350}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "Thumbnail"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "title"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" onClick={handleClickCreatedDateSort}
                                               style={{minWidth: 55}}>
                                        <Box className={classes.sortButton}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "register_date"})}</Typography>
                                            {noticeStore.sortColumn === 'register_date' &&
                                                (noticeStore.isAscending ?
                                                    <TableSortIcon style={{transform: 'scaleY(-1)'}}/> :
                                                    <TableSortIcon/>)
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "visibility"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.tableBodyStyle}>
                                {noticeStore.noticeList.map((notice, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row"
                                                   align='left'>{index + (noticeStore.page * noticeStore.rowsPerPage) + 1}</TableCell>
                                        {notice.notificationType === NotificationType.Group ? (
                                                <TableCell
                                                    align="left">
                                                    <Typography style={{fontWeight: 600}}>
                                                        {intl.formatMessage({id: `${notice.notificationType}`})}({intl.formatMessage({id: `${notice.localeCode}`})} - {notice.localeGroupName})
                                                    </Typography>
                                                </TableCell>
                                            ) :
                                            notice.notificationType === NotificationType.Locale ? (
                                                <TableCell
                                                    align="left">
                                                    <Typography style={{fontWeight: 600}}>
                                                        {intl.formatMessage({id: `${notice.notificationType}`})}({intl.formatMessage({id: `${notice.localeCode}`})})
                                                    </Typography>
                                                </TableCell>
                                            ) : (
                                                <TableCell
                                                    align="left">
                                                    <Typography style={{fontWeight: 600}}>
                                                        {intl.formatMessage({id: `${notice.notificationType}`})}
                                                    </Typography>
                                                </TableCell>
                                            )}
                                        <TableCell align="left">
                                            <Card style={{
                                                backgroundColor: `${notice.backgroundColor}`,
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                width: 328,
                                                borderRadius: 15,
                                                height: 66
                                            }}>
                                                <Box style={{
                                                    padding: '10px 15px',
                                                    display: 'flex',
                                                    justifyContent: 'center'
                                                }}>
                                                    {notice.image ? (
                                                        <img style={{width: '45px', height: '45px'}}
                                                             src={notice.image}
                                                             alt="썸네일 이미지"/>
                                                    ) : (
                                                        <img className={classes.iconBtn}
                                                             style={{width: '45px', height: '45px'}}
                                                             src={NoImage} alt='NoImage'/>
                                                    )}
                                                </Box>
                                                <Box style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    textAlign: 'left',
                                                    width: '100%'
                                                }}>
                                                    <Typography style={{
                                                        fontSize: '0.9rem',
                                                        color: 'textSecondary'
                                                    }}>{notice.title}</Typography>
                                                    <Typography style={{
                                                        fontWeight: 'bold',
                                                        fontSize: '1rem'
                                                    }}>{notice.subTitle}</Typography>
                                                </Box>
                                            </Card>
                                        </TableCell>
                                        <TableCell align="left">{notice.title}</TableCell>
                                        <TableCell
                                            align="left">{DATE_UTIL.getTimeZoneDate(notice.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                        <TableCell align="left">
                                            <Box>
                                                <FormControlLabel
                                                    control={<Switch checked={notice.enable}
                                                                     onChange={() => handleClickEnabled(notice.enable, notice.id)}
                                                                     name="checkedB" className={classes.swichStyle}/>}
                                                    labelPlacement="start"
                                                />
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button className={classes.tableButton} disableRipple
                                                    onClick={() => handelClickManage(notice.id)}>{intl.formatMessage({id: "management"})}</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 15, 20]}
                        count={noticeStore.totalCount}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                        page={noticeStore.page}
                        rowsPerPage={noticeStore.rowsPerPage}
                        component="div"
                        labelDisplayedRows={({count, page}) => {
                            return <span
                                className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / noticeStore.rowsPerPage)}</span>
                        }}
                        SelectProps={{
                            IconComponent: TextFieldDownIcon,
                            MenuProps: {
                                className: classes.selectPopover
                            }
                        }}
                        className={classes.paginationBox}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default inject('authStore', 'noticeStore', 'localeStore')(injectIntl(observer(NoticeHome)));
